// dna_frontend/components/RaSoatModal.js
// (Copy và thay thế toàn bộ file)

import React, { useState, useEffect } from 'react';
import api from '../services/api';

// (Giữ nguyên các hằng số)
const TRANG_THAI_RA_SOAT_OPTIONS = [
  { key: 'chua_ra_soat', value: 'Chưa rà soát' },
  { key: 'xac_nhan', value: 'Xác nhận đến thu mẫu' },
  { key: 'xac_nhan_bo_sung', value: 'Xác nhận tham gia thu mẫu bổ sung' },
  { key: 'khong_lien_lac', value: 'Không liên lạc được' },
  { key: 'o_xa_khong_ve', value: 'Ở xa không về' },
  { key: 'khong_ve_dung_hen', value: 'Không về đúng hẹn nhưng hẹn ngày khác trong tháng 11' }, 
  { key: 'khong_nhu_cau', value: 'Không có nhu cầu' },
  { key: 'qua_yeu', value: 'Quá yếu (không di chuyển được)' },
  { key: 'da_thu_mau_truoc', value: 'Đã thu mẫu trước 01/7/2025' }, 
  { key: 'de_nghi_xoa', value: 'Đề nghị xóa' }, 
  { key: 'du_phong', value: 'Thân nhân dự phòng' }, 
  { key: 'khac', value: 'Khác' },
];

const LY_DO_DE_NGHI_XOA_OPTIONS = [
  { key: '', value: '-- Vui lòng chọn lý do --' },
  { key: 'da_chet', value: 'Đã chết' },
  { key: 'sai_dien', value: 'Sai diện' },
  { key: 'than_nhan_thua', value: 'Thân nhân "thừa" (thân nhân 3, 4, 5...)' },
  { key: 'liet_si_tim_thay_mo', value: 'Liệt sĩ đã tìm thấy mộ' },
  { key: 'khac', value: 'Khác (ghi rõ lý do)' },
];

const STT_THAN_NHAN_OPTIONS = [
  { key: '1', value: 'Thân nhân 1' },
  { key: '2', value: 'Thân nhân 2' },
  { key: 'du_phong', value: 'STT 3, 4, 5... (Dự phòng)' }, 
];
const MOI_QUAN_HE_OPTIONS = [
  { key: '1', value: '(1) Mẹ đẻ' },
  { key: '2', value: '(2) Bà ngoại ruột' },
  { key: '3', value: '(3) Anh, chị, em cùng mẹ đẻ' },
  { key: '4', value: '(4) Anh, chị, em cùng mẹ đẻ với mẹ đẻ' },
  { key: '5', value: '(5) Con ruột của chị/em gái mẹ đẻ' },
  { key: '6', value: '(6) Con của chị/em gái' },
];


function RaSoatModal({ thanNhan, onClose, onSave, isAdminView }) { 
  
  const isLocked = (thanNhan.trang_thai_thu_mau === 'da_thu_mau') && !isAdminView;
  
  const [originalInfo, setOriginalInfo] = useState({
    ho_ten: thanNhan.ho_ten, 
    nam_sinh: thanNhan.nam_sinh || '', 
    cccd: thanNhan.cccd, 
    dia_chi: thanNhan.dia_chi 
  });
  const [info, setInfo] = useState({ ...originalInfo });
  const [review, setReview] = useState({
    trang_thai: thanNhan.trang_thai_ra_soat,
    ghi_chu: thanNhan.ghi_chu || '',
    da_cap_nhat_dc01: thanNhan.da_cap_nhat_dc01 || false,
  });
  
  const [lyDoXoa, setLyDoXoa] = useState('');
  
  const [selectedFile, setSelectedFile] = useState(null); 
  const [anhMinhChungUrl, setAnhMinhChungUrl] = useState(thanNhan.anh_minh_chung);
  const [moiQuanHeList, setMoiQuanHeList] = useState([]);
  const [isLoadingQuanHe, setIsLoadingQuanHe] = useState(true);
  const [searchTenLS, setSearchTenLS] = useState('');
  const [searchLSResult, setSearchLSResult] = useState([]);
  const [selectedLietSi, setSelectedLietSi] = useState(null);
  const [thonInfo, setThonInfo] = useState('');
  const [duplicateWarning, setDuplicateWarning] = useState('');
  const [newQuanHe, setNewQuanHe] = useState({ loai_quan_he: '1', stt_than_nhan: '1' });
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  // (fetchQuanHe)
  useEffect(() => {
    const fetchQuanHe = async () => {
      try {
        setIsLoadingQuanHe(true);
        const res = await api.get(`/than-nhan/${thanNhan.id}/quanhe`);
        setMoiQuanHeList(res.data);
      } catch (err) { console.error(err); setError('Lỗi tải danh sách liệt sĩ liên quan'); } 
      finally { setIsLoadingQuanHe(false); }
    };
    fetchQuanHe();
  }, [thanNhan.id]);
  
  // (useEffect khởi tạo lyDoXoa)
  useEffect(() => {
    if (thanNhan.trang_thai_ra_soat === 'de_nghi_xoa') {
        const ghiChu = thanNhan.ghi_chu || '';
        const predefinedReason = LY_DO_DE_NGHI_XOA_OPTIONS.find(opt => opt.value === ghiChu);
        
        if (predefinedReason) {
            setLyDoXoa(predefinedReason.key); 
        } else if (ghiChu) {
            setLyDoXoa('khac');
        } else {
            setLyDoXoa('');
        }
    }
  }, [thanNhan.trang_thai_ra_soat, thanNhan.ghi_chu]);


  // (handleSearchLietSi)
  const handleSearchLietSi = async () => {
    try {
      const res = await api.get(`/lietsi/search?ten=${searchTenLS}&xa_id=${thanNhan.xa_id}`);
      setSearchLSResult(res.data);
      setSelectedLietSi(null);
      setDuplicateWarning('');
    } catch (err) { 
        console.error(err); 
        setError(err.response?.data?.message || 'Lỗi tìm kiếm liệt sĩ.');
    }
  };
  
  // (handleAddLietSiQuanHe)
  const handleAddLietSiQuanHe = async () => {
    let lietSiId = selectedLietSi?.id;
    setError('');
    setDuplicateWarning('');
    if (newQuanHe.stt_than_nhan === 'du_phong' && review.trang_thai !== 'du_phong') {
        setError('Lỗi: STT 3, 4, 5... (Dự phòng) chỉ được gán cho thân nhân có trạng thái "Dự phòng". Vui lòng đổi trạng thái rà soát trước.');
        return;
    }
    if (newQuanHe.stt_than_nhan !== 'du_phong' && review.trang_thai === 'du_phong') {
         setError('Lỗi: Thân nhân có trạng thái "Dự phòng" bắt buộc phải chọn STT 3, 4, 5... (Dự phòng).');
         return;
    }
    if (!lietSiId) {
      if (!searchTenLS) { setError('Vui lòng nhập tên liệt sĩ'); return; }
      try {
        const res = await api.post('/lietsi', { 
            ho_ten: searchTenLS, 
            thon_info: thonInfo, 
            xa_id: thanNhan.xa_id 
        });
        lietSiId = res.data.id;
      } catch (err) {
        if (err.response?.status === 409) { setDuplicateWarning(err.response.data.message); return; }
        setError(err.response?.data?.message || 'Lỗi tạo liệt sĩ mới.'); return;
      }
    }
    try {
      const payload = {
        than_nhan_id: thanNhan.id,
        liet_si_id: lietSiId,
        loai_quan_he: newQuanHe.loai_quan_he,
        stt_than_nhan: newQuanHe.stt_than_nhan
      };
      const res = await api.post('/than-nhan/quanhe', payload); 
      setMoiQuanHeList([...moiQuanHeList, res.data]); 
      setSearchTenLS('');
      setSearchLSResult([]);
      setSelectedLietSi(null);
      setThonInfo('');
      setDuplicateWarning('');
    } catch (err) {
      setError(err.response?.data?.message || 'Lỗi khi thêm mối quan hệ');
    }
  };

  // (handleDeleteQuanHe)
  const handleDeleteQuanHe = async (quanHeId) => {
    if (!window.confirm('Bạn có chắc muốn xóa mối quan hệ này?')) return;
    try {
      await api.delete(`/than-nhan/quanhe/${quanHeId}`);
      setMoiQuanHeList(moiQuanHeList.filter(mq => mq.id !== quanHeId));
    } catch (err) { setError(err.response?.data?.message || 'Lỗi khi xóa'); }
  };
  
  
  // (handleSaveAll - đã cập nhật validation)
  const handleSaveAll = async () => {
    setIsSaving(true);
    setError('');
    
    // (Validation thông tin cá nhân)
    if (!isLocked) {
        if (!info.ho_ten || !info.nam_sinh || !info.cccd || !info.dia_chi) {
           setError('Họ tên, Năm sinh, CCCD và Địa chỉ là bắt buộc.');
           setIsSaving(false);
           return;
        }
        if (!/^\d{4}$/.test(info.nam_sinh)) {
            setError('Năm sinh phải là 4 chữ số (ví dụ: 1950).');
            setIsSaving(false);
            return;
        }
        if (info.cccd.length < 3) {
          setError('CCCD phải có ít nhất 3 ký tự (sẽ chỉ lưu 3 số cuối).');
          setIsSaving(false);
          return;
        }
    }
    
    // (Validation Rà soát)
    const hasSttDuPhong = moiQuanHeList.some(mq => mq.stt_than_nhan === 'du_phong');
    
    if (review.trang_thai !== 'de_nghi_xoa') {
        if (review.trang_thai === 'du_phong' && !hasSttDuPhong) {
            setError('Lỗi: Trạng thái "Dự phòng" yêu cầu phải gán ít nhất một STT 3, 4, 5... (Dự phòng).');
            setIsSaving(false); return;
        }
        if (review.trang_thai !== 'du_phong' && hasSttDuPhong) {
            setError('Lỗi: Thân nhân này đang giữ STT 3, 4, 5... (Dự phòng) nên trạng thái rà soát phải là "Dự phòng".');
            setIsSaving(false); return;
        }
    }
    
    if (review.trang_thai === 'qua_yeu' && !selectedFile && !anhMinhChungUrl) {
      setError('Trạng thái "Quá yếu" bắt buộc phải tải ảnh minh chứng.');
      setIsSaving(false); return;
    }
    
    if (review.trang_thai === 'khac' && !review.ghi_chu) {
      setError('Trạng thái "Khác" bắt buộc phải nhập Ghi chú.');
      setIsSaving(false); return;
    }
    
    if (review.trang_thai === 'de_nghi_xoa') {
        if (lyDoXoa === '') {
            setError('Vui lòng chọn Lý do đề nghị xóa.');
            setIsSaving(false); return;
        }
        if (lyDoXoa === 'khac' && !review.ghi_chu) {
            setError('Vui lòng ghi rõ lý do khác để đề nghị xóa.');
            setIsSaving(false); return;
        }
    }

    const statesRequiringLietSi = ['xac_nhan', 'xac_nhan_bo_sung', 'qua_yeu', 'du_phong'];
    if (statesRequiringLietSi.includes(review.trang_thai) && moiQuanHeList.length === 0) {
        setError('Các trạng thái (Xác nhận, Quá yếu, Dự phòng) bắt buộc phải có thông tin Liệt sĩ.');
        setIsSaving(false); 
        return; 
    }
    
    try {
      // (Cập nhật Info)
      if (!isLocked) { 
          const infoHasChanged = info.ho_ten !== originalInfo.ho_ten || 
                                 info.nam_sinh !== originalInfo.nam_sinh || 
                                 info.cccd !== originalInfo.cccd || 
                                 info.dia_chi !== originalInfo.dia_chi;
                                 
          const payload = {
              ho_ten: info.ho_ten,
              nam_sinh: info.nam_sinh,
              cccd: info.cccd,
              dia_chi: info.dia_chi
          };
          if (isAdminView) {
              payload.xa_id_CURRENT = thanNhan.xa_id;
          }
                                 
          if (infoHasChanged) {
            await api.put(`/than-nhan/${thanNhan.id}/info`, payload);
          }
      }
      
      // (Cập nhật Review)
      const reviewData = new FormData();
      reviewData.append('trang_thai', review.trang_thai);
      reviewData.append('ghi_chu', review.ghi_chu);
      if (thanNhan.nguon_du_lieu === 'xa_them_moi') {
         reviewData.append('da_cap_nhat_dc01', review.da_cap_nhat_dc01);
      }
      if (selectedFile) {
        reviewData.append('anh_minh_chung', selectedFile);
      }
      if (isAdminView) {
          reviewData.append('xa_id_CURRENT', thanNhan.xa_id);
      }
      await api.put(`/than-nhan/${thanNhan.id}/review`, reviewData);
      
      onSave(); 
      onClose(); 
    } catch (err) {
      setError(err.response?.data?.message || 'Lỗi khi lưu');
    } finally {
      setIsSaving(false);
    }
  };

  const handleInfoChange = (e) => setInfo({...info, [e.target.name]: e.target.value });
  
  // (*** SỬA LỖI (Yêu cầu 2) ***)
  // Viết lại hàm `handleReviewChange` để cập nhật state an toàn
  const handleReviewChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setReview(prevReview => {
        const newValue = (type === 'checkbox') ? checked : value;
        const newState = { ...prevReview, [name]: newValue };

        // This logic runs *after* the state value is set
        if (name === 'trang_thai') {
            // 1. Logic for 'de_nghi_xoa'
            if (newValue === 'de_nghi_xoa') {
                setLyDoXoa(''); // Reset dropdown
                newState.ghi_chu = ''; // Clear text
            } else {
                setLyDoXoa(''); // Reset dropdown if not 'de_nghi_xoa'
            }

            // 2. Logic for 'ghi_chu'
            const statesWithoutGhiChu = [
                'chua_ra_soat', 'xac_nhan', 'xac_nhan_bo_sung', 
                'khong_lien_lac', 'o_xa_khong_ve', 'khong_ve_dung_hen', 'khong_nhu_cau', 
                'qua_yeu', 'da_thu_mau_truoc', 'du_phong'
            ];
            
            if (statesWithoutGhiChu.includes(newValue)) {
                newState.ghi_chu = ''; // Clear text
            }
        }
        
        return newState;
    });
  };
  
  // (handleLyDoXoaChange - đã cập nhật)
  const handleLyDoXoaChange = (e) => {
      const newLyDoKey = e.target.value;
      setLyDoXoa(newLyDoKey);

      if (newLyDoKey === 'khac') {
          setReview(prev => ({ ...prev, ghi_chu: '' }));
      } else {
          const selectedOption = LY_DO_DE_NGHI_XOA_OPTIONS.find(opt => opt.key === newLyDoKey);
          setReview(prev => ({ ...prev, ghi_chu: selectedOption ? selectedOption.value : '' }));
      }
  };

  const handleNewQuanHeChange = (e) => setNewQuanHe({...newQuanHe, [e.target.name]: e.target.value });

  // (CSS giữ nguyên)
  const modalStyles = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' },
    content: { background: 'white', padding: '20px', borderRadius: '8px', width: '90%', maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto' },
    section: { marginBottom: '20px', border: '1px solid #eee', padding: '15px', borderRadius: '5px' },
    h3: { marginTop: '0', borderBottom: '2px solid #007bff', paddingBottom: '5px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' },
    inputGroup: { display: 'flex', flexDirection: 'column' },
    button: { background: '#007bff', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '4px', cursor: 'pointer', marginRight: '10px' },
    closeButton: { background: '#ccc', color: 'black' },
    error: { color: 'red', fontWeight: 'bold' },
    lockMessage: {
        background: '#fff8e1', 
        border: '1px solid #ffc107', 
        color: '#856404',
        padding: '10px', 
        borderRadius: '5px', 
        fontWeight: 'bold'
    }
  };

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.content} onClick={e => e.stopPropagation()}>
        <h2>Rà soát Thân nhân: {info.ho_ten} {isAdminView && `(Xã: ${thanNhan.xa_id})`}</h2>
        {error && <p style={modalStyles.error}>{error}</p>}
        
        {isLocked && (
            <p style={modalStyles.lockMessage}>
              Thông tin cá nhân đã bị KHÓA vì thân nhân này đã được Tỉnh thu mẫu.
              <br/>
              Bạn chỉ có thể sửa "Trạng thái Rà soát" và "Thông tin Liệt sĩ".
            </p>
        )}

        {/* --- PHẦN 1: THÔNG TIN CƠ BẢN --- */}
        <div style={modalStyles.section}>
          <h3 style={modalStyles.h3}>1. Thông tin Thân nhân</h3>
           <div style={modalStyles.grid}>
            <div style={modalStyles.inputGroup}>
                <label>Họ tên:</label>
                <input name="ho_ten" value={info.ho_ten} onChange={handleInfoChange} disabled={isLocked} />
            </div>
            <div style={modalStyles.inputGroup}>
                <label>Năm sinh (YYYY):</label>
                <input 
                  type="text" 
                  name="nam_sinh" 
                  value={info.nam_sinh} 
                  onChange={handleInfoChange} 
                  placeholder="YYYY (ví dụ: 1950)"
                  maxLength={4}
                  disabled={isLocked}
                />
            </div>
            <div style={modalStyles.inputGroup}>
                <label>CCCD (sẽ chỉ lưu 3 số cuối):</label>
                <input name="cccd" value={info.cccd} onChange={handleInfoChange} placeholder="Nhập CCCD (lưu 3 số cuối)" disabled={isLocked} />
            </div>
            <div style={modalStyles.inputGroup}>
                <label>Địa chỉ:</label>
                <input name="dia_chi" value={info.dia_chi} onChange={handleInfoChange} disabled={isLocked} />
            </div>
          </div>
        </div>
        
        {/* --- PHẦN 2: THÔNG TIN RÀ SOÁT --- */}
        <div style={modalStyles.section}>
          <h3 style={modalStyles.h3}>2. Trạng thái Rà soát</h3>
          <div style={modalStyles.grid}>
            <div style={modalStyles.inputGroup}>
              <label>Trạng thái:</label>
              <select name="trang_thai" value={review.trang_thai} onChange={handleReviewChange}>
                {TRANG_THAI_RA_SOAT_OPTIONS.map(opt => (<option key={opt.key} value={opt.key}>{opt.value}</option>))}
              </select>
            </div>
            
            {review.trang_thai === 'qua_yeu' && ( <div style={modalStyles.inputGroup}> <label>Tải ảnh minh chứng (bắt buộc):</label> <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} accept="image/*" /> {anhMinhChungUrl && !selectedFile && ( <p>Đã có ảnh. <a href={`http://localhost:5000/${anhMinhChungUrl}`} target="_blank" rel="noopener noreferrer">(Xem ảnh)</a></p> )} </div> )}
            
            { review.trang_thai === 'khac' && ( 
                <div style={modalStyles.inputGroup}> 
                    <label>Ghi chú (Bắt buộc):</label> 
                    <textarea 
                        name="ghi_chu" 
                        value={review.ghi_chu} 
                        onChange={handleReviewChange} 
                        placeholder="Ghi rõ lý do..." 
                    /> 
                </div> 
            )}
            
            { review.trang_thai === 'de_nghi_xoa' && (
              <>
                <div style={modalStyles.inputGroup}>
                  <label>Lý do Đề nghị xóa (Bắt buộc):</label>
                  <select name="ly_do_xoa" value={lyDoXoa} onChange={handleLyDoXoaChange}>
                    {LY_DO_DE_NGHI_XOA_OPTIONS.map(opt => (<option key={opt.key} value={opt.key}>{opt.value}</option>))}
                  </select>
                </div>
                { lyDoXoa === 'khac' && (
                  <div style={modalStyles.inputGroup}> 
                      <label>Ghi rõ lý do khác (Bắt buộc):</label> 
                      <textarea 
                          name="ghi_chu" 
                          value={review.ghi_chu} 
                          onChange={handleReviewChange} 
                          placeholder="Ghi rõ lý do đề nghị xóa..." 
                      /> 
                  </div> 
                )}
              </>
            )}

            {thanNhan.nguon_du_lieu === 'xa_them_moi' && ( <div style={{ ...modalStyles.inputGroup, flexDirection: 'row', alignItems: 'center' }}> <input type="checkbox" name="da_cap_nhat_dc01" id="dc01_check" checked={review.da_cap_nhat_dc01} onChange={handleReviewChange} style={{width: 'auto', marginRight: '10px'}} /> <label htmlFor="dc01_check" style={{fontWeight: 'bold'}}>Đã cập nhật lên DC01 mở rộng</label> </div> )}
          </div>
        </div>

        {/* --- PHẦN 3: THÔNG TIN LIỆT SĨ --- */}
        {review.trang_thai !== 'de_nghi_xoa' ? (
          <div style={modalStyles.section}>
            <h3 style={modalStyles.h3}>3. Thông tin Liệt sĩ liên quan</h3>
            {isLoadingQuanHe ? <p>Đang tải...</p> : (
              <table style={{width: '100%', borderCollapse: 'collapse'}}>
                <thead><tr><th style={{ padding: '8px', border: '1px solid #ccc' }}>Họ tên Liệt sĩ</th><th style={{ padding: '8px', border: '1px solid #ccc' }}>Quan hệ</th><th style={{ padding: '8px', border: '1px solid #ccc' }}>STT</th><th style={{ padding: '8px', border: '1px solid #ccc' }}>Xóa</th></tr></thead>
                <tbody>
                  {moiQuanHeList.map(mq => (
                    <tr key={mq.id}>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{mq.ho_ten} {mq.thon_info && `(${mq.thon_info})`}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{MOI_QUAN_HE_OPTIONS.find(o => o.key === String(mq.loai_quan_he))?.value}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc' }}>{STT_THAN_NHAN_OPTIONS.find(o => o.key === mq.stt_than_nhan)?.value || mq.stt_than_nhan}</td>
                      <td style={{ padding: '8px', border: '1px solid #ccc', textAlign: 'center' }}>
                        <button style={{background: 'red', color: 'white', cursor: 'pointer'}} onClick={() => handleDeleteQuanHe(mq.id)}>Xóa</button>
                      </td>
                    </tr>
                  ))}
                  {moiQuanHeList.length === 0 && (<tr><td colSpan="4" style={{textAlign: 'center', fontStyle: 'italic', color: 'gray', padding: '10px'}}>Chưa có liệt sĩ nào được thêm.</td></tr>)}
                </tbody>
              </table>
            )}
            
            <fieldset style={{border: 'none', padding: 0, margin: 0}}>
              <div style={{marginTop: '20px', background: '#f9f9f9', padding: '10px'}}>
                <h4>Thêm Liệt sĩ</h4>
                <p style={{ fontStyle: 'italic', color: '#0056b3', fontSize: '14px', margin: '5px 0 15px 0', background: '#e6f7ff', border: '1px solid #b3e0ff', padding: '10px', borderRadius: '5px' }}>
                  <strong>Lưu ý:</strong> Nếu thân nhân là thân nhân số 2 của liệt sĩ thì điền tên liệt sĩ và ấn "Tìm", sau đó chọn liệt sĩ trong danh sách, điền mối quan hệ, chọn số thứ tự thân nhân 2 và ấn "Thêm vào danh sách".
                </p>
                 <div style={modalStyles.inputGroup}>
                  <label>Tìm hoặc nhập tên Liệt sĩ:</label>
                  <div style={{display: 'flex'}}>
                    <input value={searchTenLS} onChange={(e) => setSearchTenLS(e.target.value)} placeholder="Nhập tên (hoặc để trống) rồi Tìm" style={{flex: 1}}/>
                    <button type="button" onClick={handleSearchLietSi}>Tìm</button>
                  </div>
                </div>
                {searchLSResult.length > 0 && ( <div style={{border: '1px solid #ccc', padding: '5px', maxHeight: '100px', overflowY: 'auto'}}> <p>Chọn liệt sĩ đã có (Xã {thanNhan.xa_id}):</p> {searchLSResult.map(ls => ( <div key={ls.id} onClick={() => { setSelectedLietSi(ls); setSearchTenLS(ls.ho_ten); setThonInfo(ls.thon_info || ''); setSearchLSResult([]); }} style={{padding: '5px', cursor: 'pointer', background: '#eee', marginBottom: '2jpx'}}> {ls.ho_ten} {ls.thon_info && `(${ls.thon_info})`} </div> ))} </div> )}
                {duplicateWarning && ( <div style={{...modalStyles.error, border: '1px solid red', padding: '10px', margin: '10px 0'}}> <p>{duplicateWarning}</p> <div style={modalStyles.inputGroup}> <label>Thông tin Thôn/Xóm (để phân biệt):</label> <input value={thonInfo} onChange={(e) => setThonInfo(e.target.value)} /> </div> </div> )}
                <div style={{...modalStyles.grid, gridTemplateColumns: '1fr 1fr', marginTop: '10px'}}>
                  <div style={modalStyles.inputGroup}><label>Mối quan hệ:</label><select name="loai_quan_he" value={newQuanHe.loai_quan_he} onChange={handleNewQuanHeChange}>{MOI_QUAN_HE_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}</select></div>
                  <div style={modalStyles.inputGroup}><label>Số thứ tự thân nhân:</label><select name="stt_than_nhan" value={newQuanHe.stt_than_nhan} onChange={handleNewQuanHeChange}>{STT_THAN_NHAN_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}</select></div>
                </div>
                <button type="button" onClick={handleAddLietSiQuanHe} style={{marginTop: '10px', ...modalStyles.button}}>+ Thêm vào danh sách</button>
              </div>
            </fieldset>
          </div>
        ) : (
          <div style={{ ...modalStyles.section, background: '#fef2f2', borderColor: '#fecaca' }}>
            <h3 style={{ ...modalStyles.h3, color: '#991b1b' }}>3. Xác nhận Đề nghị xóa</h3>
            <p style={{color: '#991b1b', fontWeight: 'bold'}}>
              Bạn đã chọn "Đề nghị xóa". Thông tin Liệt sĩ sẽ được bỏ qua.
              <br/>
              Hãy chắc chắn rằng bạn đã chọn/nhập "Lý do Đề nghị xóa" ở Mục 2.
            </p>
          </div>
        )}

        {/* --- NÚT LƯU/HỦY --- */}
        <div style={{textAlign: 'right', marginTop: '20px'}}>
          <button style={{...modalStyles.button, ...modalStyles.closeButton}} onClick={onClose} disabled={isSaving}> Hủy </button>
          <button style={modalStyles.button} onClick={handleSaveAll} disabled={isSaving}> {isSaving ? 'Đang lưu...' : 'Lưu tất cả thay đổi'} </button>
        </div>
      </div>
    </div>
  );
}

export default RaSoatModal;